<div data-cy="add-user-dialog">
  <div mat-dialog-title class="header">
    Confirm Removal
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <p>Total Removal Clawback Required: {{ data.totalRemovalErt  | number: '1.0-4' }}</p>
    <form [formGroup]="removalForm" class="new-user-form">
      <mat-form-field class="full-width">
        <mat-label>Spread Clawback</mat-label>
        <input formControlName="clawbackPeriods"
               matInput
               data-cy="clawbackPeriods-input"
               name="clawbackPeriods"
               type="number" min="1" [max]="unPaidPaymentPeriods.length" (change)="updatePeriod()" />
        <mat-hint>Over how many periods should the clawback occur?
          Must be between 1 and {{ unPaidPaymentPeriods.length }}.
        </mat-hint>
      </mat-form-field>
    </form>
    <p>By removing this area, the following changes will take effect:</p>
    <p>Old Annual Gross ERT: {{ currentValuation }} </p>
    <p>New Annual Gross ERT: {{ currentValuation - data.removalValuation  | number: '1.0-4' }} </p>
    <p>Next {{ removalForm.controls.clawbackPeriods.value }} payment Periods: </p>
    <p>Gross ERT {{ perPeriodGross | number: '1.0-4' }}</p>
    <p>Removal
      Deduction: {{ perPeriodRemoval | number: '1.0-4' }}</p>
    <p>Buffer Values: {{ perPeriodBuffer | number: '1.0-4' }}</p>
    <p>Net ERT: {{ pendingNetErt | number: '1.0-4' }} </p>
  </div>
  <div mat-dialog-actions>
    <button [mat-dialog-close]="null" mat-stroked-button color="primary" mat-dialog-close data-cy="cancel-button">
      CANCEL
    </button>
    <button
      (click)="submitRemoval()"
      [disabled]="removalForm.invalid"
      color="primary"
      data-cy="submit-button"
      mat-raised-button>
      Accept Changes
    </button>
  </div>
</div>
